define((require) => {
    "use strict";

    const _                                         = require("underscore");
    const Backbone                                  = require("backbone");
    const TemplateItemView                          = require("ui/dashboard/TemplateItemView");
    const ContentQuery                              = require("data/ContentQuery");
    const CreateNewExperienceView                   = require("ui/dashboard/CreateNewExperienceView");
    const TemplateSortingPanel                      = require("ui/dashboard/TemplateSortingPanel");
    const DashboardHeaderFactory                    = require("ui/dashboard/DashboardHeaderFactory");
    const ImprovedView                              = require("editor/zbone/ImprovedView");
    const InfiniteScrollingCollectionView           = require("ui/common/InfiniteScrollingCollectionView");
    const NoResultsItemView                         = require("zbone/NoResultsItemView");
    const Privileges                                = require("shared/security/Permissions").Privileges;
    const Syncer                                    = require("shared/services/sync/Syncer");
    const TemplateContentCollectionViewTemplate     = require("ui/dashboard/TemplateContentCollectionView.tpl");

    /**
     *
     * @class TemplateContentCollectionView
     *
     */
    return ImprovedView.extend({

        className: "content-collection-view",

        template: TemplateContentCollectionViewTemplate,

        itemView: TemplateItemView,

        itemViewOptions: {},

        createLabelOptions: function() {
            return {
                label: "Create<br> New Blank Experience<br> &#43",
                onClick: () => {
                    Backbone.history.navigate("experience/create", {trigger: true});
                    this.options.closeQuickView();
                },
                additionalClassName: "create-template-content-item"
            };
        },

        _collectionView: null,

        _sortingPanel: null,

        _showCreateDisclaimer: true,

        regions: {
            sortingPanelRegion: ".sorting-panel-region",
            content: ".content"
        },

        ui: {
            content: ".content"
        },

        initialize: function() {
            this.collection = this.options.collection;
            this.itemViewOptions = this.options.itemViewOptions || this.itemViewOptions;
            this.itemViewOptions.closeQuickView = this.options.closeQuickView;
            this._showCreateDisclaimer = this.options.showCreateDisclaimer !== false && Privileges.CREATE.can();

            const dashboardHeaderFactoryOptions = _.pick(this.options, "users", "principal");
            this.dashboardHeaderFactory = new DashboardHeaderFactory(dashboardHeaderFactoryOptions);
        },

        /**
         * Exposes the event source (most likely a collection) associated with the number of
         * items represented by  *this* dashboard sub view. The dashboard will use this for updating
         * the counting labels, by listening for relevant events.
         *
         * @return {Collection} The main collection for this dashboard sub view.
         *
         * @see DashboardView#showTab
         */
        getCountableEventSource: function() {
            return this.collection;
        },

        /**
         * @override
         *
         * We don't need Marionette's serialization here.
         */
        serializeData: function() {
            return {};
        },

        onShow: function() {
            this._sortingPanel = new TemplateSortingPanel();
            this.sortingPanelRegion.show(this._sortingPanel);

            this._collectionView = new InfiniteScrollingCollectionView({
                itemView: this.itemView,
                itemViewOptions: this.itemViewOptions,
                itemEvents: this._bindItemEvents(),
                collection: this.collection,
                horizontalBuffer: 220,
                scrollTarget: _.result(this.options, "scrollTarget")
            });

            this.listenTo(this.collection, {
                "sync:state": function() { // only used for fetch
                    this._sortingPanel.disable(!Syncer.State.complete(this.collection));
                },

                "remove": function() {
                    // Edge case: If we're in "search mode" and deletes the last experience/group, call
                    // refresh to update the view, eventually displaying "No content found" (since we're still in "search mode")...
                    if (this.collection.length() === 0 && this._sortingPanel.isSearching()) {
                        this.refresh();
                    }
                },

                "reset": function() {
                    this.dashboardHeaderFactory.reset();
                }
            });

            this.listenTo(this._sortingPanel, {
                "sort": function(sorting) {
                    this.collection.query(sorting.query);
                },

                "search": function(searchPhrase, sorting) {
                    this.collection.query(ContentQuery.search(searchPhrase, sorting.query));
                }
            });

            this._collectionView.onAddingView = this.onAddingView.bind(this);

            this._collectionView.onEmpty = function() {
                if (this._sortingPanel.isSearching()) {
                    return new NoResultsItemView({type: "template"});
                }

                return this._createDisclaimer();
            }.bind(this);

            this.content.show(this._collectionView);
        },

        refresh: function(sorting) {
            this.dashboardHeaderFactory.reset();

            this._sortingPanel.setSorting(sorting || this.getSorting());
        },

        /**
         * Invoked from the dashboard view when the tab representing this view become active/deactive.
         *
         * @param  {Boolean} active The active state.
         */
        active: function(active) {
            // Delegate active state to the InfiniteScrollingCollectionView
            // instance - this will enable/disable the scroll listener.
            this._collectionView.active(active);

            if (active) {
                this.refresh();
            }
        },

        setSorting: function(sorting) {
            this._sortingPanel.setSorting(sorting);
        },

        getSorting: function() {
            return this._sortingPanel.getSorting();
        },

        onAddingView: function(view, index) {
            if (this._collectionView.at(index)) {
                return;
            }

            const header = this.dashboardHeaderFactory.create(this._sortingPanel.getSorting(), index, view.model);

            if (index === 0) {
                const createItem = this._createDisclaimer();

                return createItem ? [header, createItem] : header;
            }

            return header;
        },

        _createDisclaimer: function() {
            if (this._showCreateDisclaimer) {
                return new CreateNewExperienceView(this.createLabelOptions());
            }
            // undefined...
        },

        _bindItemEvents: function() {
            const self = this,
                itemEvents = {};

            if (itemEvents) {
                _.each(this.itemEvents, (callback, event) => {
                    itemEvents[event] = callback.bind(self);
                });
            }

            return itemEvents;
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/dashboard/TemplateContentCollectionView.js